import axios from "axios";
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  baseURL:
    process.env.VUE_APP_API_URL || "https://quickleapapi.herokuapp.com/v1/",
  headers: {
    "Content-Type": "application/json"
    // timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
  }
  /* validateStatus: function(status) {
    return status === 400;
  } */
};

export const http = axios.create(config);

// Add a 401 response interceptor
http.interceptors.response.use(
  function(response) {
    return response.data;
  },
  function(error) {
    const errorStatus = error.response.status;
    let errorMsg = error.response.data.message;
    if (401 === errorStatus || 400 === errorStatus || 500 === errorStatus) {
      if (500 === errorStatus) errorMsg = error.response.data.errors.message;
      return Promise.reject(errorMsg);
    } else {
      return Promise.reject(error);
    }
  }
);
